import React from 'react';
import { cn } from '@cotera/client/v0/lib/utils';

/**
 * The mark for an artifact with unsaved changes.
 *
 * One component because it shows in three places at once — the panel's artifact
 * label, the switcher menu's rows, and the artifacts index card — and "unsaved"
 * has to look identical in all of them or it stops reading as one fact about one
 * artifact and starts reading as three unrelated dots. Whether an artifact *is*
 * dirty lives in `artifact-dirty-state.ts`; this is only how that shows.
 *
 * Amber, not the destructive red: unsaved work is a state, not a fault.
 *
 * Carries its own `aria-label` rather than leaving that to callers — it is the
 * only thing here a screen reader can read, and a bare dot with no label is
 * indistinguishable from decoration.
 */
export const ArtifactDirtyDot: React.FC<{ className?: string }> = ({
  className,
}) => (
  <span
    aria-label="Unsaved changes"
    className={cn('size-1.5 shrink-0 rounded-full bg-amber-500', className)}
  />
);
